export default __webpack_public_path__ + "static/media/13.f848678d.jpeg";